import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      title: '快速链接',
      items: [
        { label: '首页', to: '/' },
        { label: '游戏分类', to: '/category' },
        { label: '关于我们', to: '/about' },
      ],
    },
    {
      title: '平台服务',
      items: [
        { label: 'j9注册', to: '#' },
        { label: 'j9登录入口', to: '#' },
        { label: '优惠活动', to: '#promotions' },
        { label: '安全保障', to: '/about#security' },
      ],
    },
    {
      title: '帮助支持',
      items: [
        { label: '常见问题', to: '/#faq' },
        { label: '联系我们', to: '/about#contact' },
        { label: '用户协议', to: '#' },
        { label: '隐私政策', to: '#' },
      ],
    },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-bold text-accent-500">
                  j9
                </span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed">
                j9是备受用户信赖的综合娱乐平台，提供丰富游戏体验、安全支付保障与极速提款服务，为您打造极致娱乐享受。
              </p>
            </div>

            {footerLinks.map((section) => (
              <div key={section.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-2.5">
                  {section.items.map((item) => (
                    <li key={item.label}>
                      {item.to.startsWith('#') || item.to === '#' ? (
                        <a
                          href={item.to}
                          className="text-sm text-foreground-300 hover:text-accent-400 transition-colors"
                        >
                          {item.label}
                        </a>
                      ) : (
                        <Link
                          to={item.to}
                          className="text-sm text-foreground-300 hover:text-accent-400 transition-colors"
                        >
                          {item.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">{t('footer_copyright')}</p>
            <p className="text-xs text-foreground-500">{t('footer_disclaimer')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}